<div class="h-100" *ngIf="(nameComponentCir == 'LISTAR')">
    <app-geocerca-circular-lists></app-geocerca-circular-lists>
  </div>
  
  <div class="h-100" *ngIf="(nameComponentCir == 'AGREGAR')">
    <app-geocerca-circular-add></app-geocerca-circular-add>
  </div>